export default __webpack_public_path__ + "static/media/Notifications_icon.9f4fe18d.svg";